import '../index.css';

export default function Pricing() {
  return (
    <section id="planos" className="pricing-section">
      <div className="section-inner">
        <p className="section-label">💰 PLANOS E PREÇOS</p>
        <h2 className="section-title">Planos da Extensão</h2>
        <p className="section-subtitle">Escolha o período ideal para você usar o Lovable sem limites</p>

        <div className="pricing-grid four-cols">
          {/* Semanal */}
          <div className="plan-card plan-gold">
            <div className="plan-header">
              <p className="plan-period">SEMANAL</p>
              <div className="plan-price">
                <span className="currency">R$</span>99,90
              </div>
              <p className="plan-duration">7 DIAS DE USO ILIMITADO</p>
            </div>
            <ul className="plan-features">
              <li><span className="check-icon">✓</span> Uso ilimitado</li>
              <li><span className="check-icon">✓</span> Todas funcionalidades</li>
              <li><span className="check-icon">✓</span> Suporte no WhatsApp</li>
            </ul>
            <a href="https://wa.me/5511964768245?text=Ol%C3%A1!%20Quero%20o%20plano%20SEMANAL%20de%20R%24%2099%2C90" target="_blank" rel="noopener noreferrer" className="plan-cta gold">COMEÇAR AGORA</a>
          </div>

          {/* 14 Dias */}
          <div className="plan-card plan-emerald">
            <div className="plan-header">
              <p className="plan-period">14 DIAS</p>
              <div className="plan-price">
                <span className="currency">R$</span>129,90
              </div>
              <p className="plan-duration">14 DIAS DE USO ILIMITADO</p>
            </div>
            <ul className="plan-features">
              <li><span className="check-icon">✓</span> Uso ilimitado</li>
              <li><span className="check-icon">✓</span> Todas funcionalidades</li>
              <li><span className="check-icon">✓</span> Todos os bônus</li>
              <li><span className="check-icon">✓</span> Suporte no WhatsApp</li>
            </ul>
            <a href="https://wa.me/5511964768245?text=Ol%C3%A1!%20Quero%20o%20plano%2014%20DIAS%20de%20R%24%20129%2C90" target="_blank" rel="noopener noreferrer" className="plan-cta emerald">COMEÇAR AGORA</a>
          </div>

          {/* Mensal - MAIS VENDIDO */}
          <div className="plan-card plan-purple featured">
            <div className="plan-badge">🔥 MAIS VENDIDO</div>
            <div className="plan-header">
              <p className="plan-period">MENSAL</p>
              <div className="plan-price">
                <span className="currency">R$</span>157
              </div>
              <p className="plan-duration">30 DIAS DE USO ILIMITADO</p>
            </div>
            <ul className="plan-features">
              <li><span className="check-icon">✓</span> Uso ilimitado</li>
              <li><span className="check-icon">✓</span> Todas funcionalidades</li>
              <li><span className="check-icon">✓</span> Todos os bônus</li>
              <li><span className="check-icon">✓</span> Grupo VIP</li>
              <li><span className="check-icon">✓</span> Suporte prioritário</li>
              <li><span className="check-icon">✓</span> Recebe as atualizações primeiro</li>
              <li><span className="check-icon">✓</span> Sorteios mensais da extensão</li>
              <li><span className="check-icon">✓</span> Botão para remover marca d'água</li>
            </ul>
            <a href="https://wa.me/5511964768245?text=Ol%C3%A1!%20Quero%20o%20plano%20MENSAL%20de%20R%24%20157" target="_blank" rel="noopener noreferrer" className="plan-cta">COMEÇAR AGORA</a>
          </div>
        </div>

        <div className="payment-methods-container">
          <p className="payment-methods-title text-center font-medium text-xl">💳 Formas de Pagamento Aceitas</p>
          <img
            src="https://static.lumi.new/7b/7b020ca120538beffb24d2d9416b7d42.webp"
            alt="Formas de pagamento: PIX, Boleto, PayPal, Visa, Mastercard, Elo"
            className="payment-methods-image" />

          <p className="pricing-note">Parcelamento em até 12x no cartão • Pagamento 100% seguro</p>
        </div>

        {/* English Version - Value in Dollars */}
        













































































      </div>
    </section>);

}